import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getDashboardLeaves, getDashboardAttendance } from '../../../services/services';

export const dashboardLeavesData = createAsyncThunk('getDashboardleaves', async (id, thunkAPI) => {
	try {
		const response = await getDashboardLeaves(id);
		return response?.data;
	} catch (error) {
		return thunkAPI.rejectWithValue(error);
	}
});

export const dashboardAttendanceData = createAsyncThunk(
	'getDashboardAttendances',
	async (id, thunkAPI) => {
		try {
			const response = await getDashboardAttendance(id);
			return response?.data;
		} catch (error) {
			return thunkAPI.rejectWithValue(error);
		}
	},
);

const attendanceSlice = createSlice({
	name: 'attendance',
	initialState: {
		data: null,
		loading: false,
		error: null,
		attendanceData: null,
		attendanceLoading: false,
		attendanceError: null,
	},
	reducers: {},
	extraReducers: (builder) => {
		builder
			.addCase(dashboardLeavesData.pending, (state) => {
				state.loading = true;
				state.error = null;
			})
			.addCase(dashboardLeavesData.fulfilled, (state, action) => {
				state.loading = false;
				state.data = action.payload;
			})
			.addCase(dashboardLeavesData.rejected, (state, action) => {
				state.loading = false;
				state.error = action.payload;
			})

			.addCase(dashboardAttendanceData.pending, (state) => {
				state.attendanceLoading = true;
				state.attendanceError = null;
			})
			.addCase(dashboardAttendanceData.fulfilled, (state, action) => {
				state.attendanceLoading = false;
				state.attendanceData = action.payload;
			})
			.addCase(dashboardAttendanceData.rejected, (state, action) => {
				state.attendanceLoading = false;
				state.attendanceError = action.payload;
			});
	},
});

export default attendanceSlice.reducer;
